import {i18n} from '@/plugins/i18n';
import {settlementRequestStatusStr, settlementRequestStatusVariant} from "@/constants/settlementRequestStatus";
import {settlementRequestTypeStr, settlementRequestTypeVariant} from "@/constants/settlementRequestType";

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'shop',
        title: i18n.t('label.gateway'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'user',
        title: i18n.t('label.user'),
        sortable: false,
        template: row => {
            return `
                <span>
                    <a href="/users/${row.user.hashid}/details" target="_blank">${row.user.full_name}</a>
                </span>`
                ;
        },
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('label.amount_rial'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'destination',
        title: i18n.t('settlement_request.sheba_number_or_wallet_id'),
        sortable: false,
        width: 200,
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('label.type'),
        sortable: true,
        template: row => {
            return `<span class="badge badge-${settlementRequestTypeVariant(row.type)}">${settlementRequestTypeStr.get(row.type)}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        sortable: true,
        template: row => {
            return `<span class="badge badge-${settlementRequestStatusVariant(row.status)}">${settlementRequestStatusStr.get(row.status)}</span>`;
        },
        textAlign: 'center',
    },
]
